import * as React from 'react';
import { AuthorizedForm } from '../api/clients';

const AuthorizedFormData = React.createContext<AuthorizedForm>(undefined!);

export function AuthorizedFormDataProvider({ children, authorizedFormData }: {
  children: React.ReactNode,
  authorizedFormData: AuthorizedForm,
}) {
  return (
    <AuthorizedFormData.Provider value={authorizedFormData}>
      {children}
    </AuthorizedFormData.Provider>
  );
}

export const useAuthorizedFormData = () => React.useContext(AuthorizedFormData);
